module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" 设置密码 ")]), _vm._v(" "), _c('div', {
    staticClass: "input-box m-b-10",
    class: {
      error: !!_vm.errorText
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入您的新密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box m-b-10",
    class: {
      error: !!_vm.errorText
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repetPass),
      expression: "repetPass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入再次确认您的新密码"
    },
    domProps: {
      "value": (_vm.repetPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repetPass = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    staticStyle: {
      "margin-top": "50px"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("完成")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-599195be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/mmzhSteptwo.vue
// module id = 882
// module chunks = 1